<template>
  <BaseButton primary outline class="w-full" @click="addMedia"> Add Media </BaseButton>
</template>

<script>
export default {
  inject: ['refreshAccProduct'],
  props: {
    accProductId: {
      type: String,
      required: true,
    },
  },
  methods: {
    addMedia() {
      this.$modal.show({
        component: () => import('./AddMediaModal.vue'),
        props: {
          accProductId: this.accProductId,
        },
        on: {
          saved: () => {
            this.refreshAccProduct();
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
